export default "__VITE_ASSET__877430c8__"